import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    computed,
    ElementRef,
    input,
    Input,
    ViewChild
} from '@angular/core';
import { PlatformService } from '@core/services/platform.service';
import { isElementInViewport } from '@utils/viewport.helper';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SvgIconComponent, NgClass]
})
export class TooltipComponent implements AfterViewInit {
    position = input<'right' | 'top'>('top');
    positionInit = computed(() => ({
        right: this.position() === 'right'
    }));

    @Input() type: 'default' | 'warning' = 'default';

    @ViewChild('tooltipContent') tooltipContent: ElementRef;

    constructor(private readonly platformService: PlatformService) {}

    ngAfterViewInit(): void {
        if (this.platformService.isServer) {
            return;
        }

        this.checkElement();
    }

    public onMouseEnter(): void {
        this.checkElement();
    }

    private checkElement(): void {
        const isInViewport = isElementInViewport(this.tooltipContent?.nativeElement);

        if (!isInViewport) {
            this.positionInit().right = true;
        }
    }
}
